// Final edited
<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-card
        min-width="300px"
        max-width="350"
        class="px-6 py-3"
        elevation="0"
        rounded="xl"
        dark
      >
        <v-card-title class="d-block pb-0">
          <h1
            class="text-h2 font-weight-light text-center"
            :class="checkTypeColor"
          >
            {{ checkTypeText }}
          </h1>
          <h5 class="text-overline font-weight-bold text-center mb-3">
            · · · access · · · vid · · ·
          </h5>
          <v-row class="pa-2 rounded-lg">
            <v-col cols="12">
              <div>
                <h1 class="text-h5 text-center">
                  {{ okOrDenied }}
                </h1>
                <h1 v-if="valid && !loading" class="text-h4 text-center">
                  {{ welcome }}
                </h1>
              </div>
              <v-card class="text-center" raised elevation="2" rounded="xl">
                <v-card-title v-if="writing" class="justify-center text-h3">{{
                  code
                }}</v-card-title>
                <v-card-text class="text-h6">
                  <v-avatar v-if="!filledCode" color="grey" size="124">
                    <span class="white--text"></span
                    ><v-icon dark x-large class="custom-icon-large">
                      mdi-qrcode-scan
                    </v-icon>
                  </v-avatar>
                  <v-progress-circular
                    v-else-if="loading"
                    :rotate="360"
                    :size="100"
                    :width="20"
                    :value="waitingResponse"
                    color="grey"
                  >
                  </v-progress-circular>
                  <v-avatar
                    v-else-if="validCode"
                    color="teal darken-1"
                    size="124"
                  >
                    <span class="white--text"></span
                    ><v-icon dark x-large class="custom-icon-large">
                      {{ checkIcon }}
                    </v-icon>
                  </v-avatar>
                  <v-avatar v-else color="red accent-3" size="124">
                    <span class="white--text"></span
                    ><v-icon dark x-large class="custom-icon-large">
                      mdi-cancel
                    </v-icon>
                  </v-avatar>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-text-field
              prepend-inner-icon="mdi-key-plus"
              label="Digita el código"
              type="number"
              required
              autocomplete="off"
              pattern="[0-9]*"
              min="1"
              max="999999"
              :maxlength="codeLength"
              v-model="code"
              clearable
              @click:clear="clearMessage"
              height="70"
              :rules="rules.code"
              :hint="hint"
              loading
              outlined
              class="custom-input mb-12 text-center"
              :counter="codeLength"
              :color="color"
              hide-details="auto"
              shaped
              ><template v-slot:progress>
                <v-progress-linear
                  :value="progress"
                  :color="color"
                  absolute
                  height="7"
                ></v-progress-linear> </template
            ></v-text-field>
          </v-form>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { CODE_LENGTH } from '@/cfg'
import { sendCheck } from '@/store/modules/passApi/fbCheckApi'
export default {
  data: () => ({
    responseInterval: {},
    waitingResponse: 0,
    checkType: '',
    fromTheBegining: true,
    valid: false,
    validCode: false,
    name: '',
    messages: '',
    code: '',
    codeSent: '',
    hint: '',
    loading: false,
    rules: {
      code: [
        v => !!v || 'Es requerido para comprobar su pase de entrada',
        v => (v && v.length == CODE_LENGTH) || 'Se esperan 6 dígitos'
      ]
    }
  }),
  computed: {
    ...mapGetters('user', ['context']),
    checkIcon() {
      return this.checkType === 'checkin'
        ? 'mdi-check-circle'
        : this.checkType === 'checkout'
        ? 'mdi-hand'
        : 'mdi-help'
    },
    checkTypeText() {
      return !this.valid || this.checkType === ''
        ? 'Registro'
        : this.checkType === 'checkin'
        ? 'Entrada'
        : this.checkType === 'checkout'
        ? 'Salida'
        : ''
    },
    checkTypeColor() {
      if (!this.filledCode) {
        return 'identity--text'
      } else if (this.validCode) {
        return this.checkType === 'checkin'
          ? 'teal--text text--darken-1'
          : 'teal--text text--darken-1'
      } else {
        return 'red--text text--accent-3'
      }
    },
    welcome() {
      const salutation =
        this.checkType === 'checkin'
          ? 'Hola!'
          : this.checkType === 'checkout'
          ? '¡Adiós!'
          : ''
      return this.validCode
        ? `${salutation} ${this.name}`
        : this.checkType === 'unknown'
        ? `ACCESSO DENEGADO`
        : `*DENEGADA* ${this.name}`
    },
    okOrDenied() {
      if (this.fromTheBegining) return ''
      return this.valid ? 'Válido' : 'Denegado'
    },
    writing() {
      return this.code && this.code.length > 0
    },
    filledCode() {
      return !!this.code && this.code.length === CODE_LENGTH
    },
    codeLength() {
      return CODE_LENGTH
    },
    currentLength() {
      return this.code ? this.code.length : 0
    },
    progress() {
      return Math.min(100, (this.currentLength * 100) / CODE_LENGTH)
    },
    color() {
      return !this.filledCode
        ? ['error', 'warning', 'white'][Math.floor(this.progress / 40)]
        : this.validCode
        ? 'teal'
        : 'white'
    }
  },
  watch: {
    valid(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.check().catch(error => console.log('Can not validate it', error))
      }
    }
  },
  methods: {
    ...mapActions('user', ['login']),
    clearMessage() {
      this.reset()
    },
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.clearResponseInterval()
      this.fromTheBegining = true
      this.$refs.form.reset()
      this.validCode = false
      this.checkType = ''
    },
    resetValidation() {
      this.fromTheBegining = true
      this.$refs.form.resetValidation()
    },
    clearResponseInterval() {
      if (Object.keys(this.responseInterval).length === 0) {
        clearInterval(this.responseInterval)
        this.responseInterval = {}
      }
    },
    async check() {
      this.loading = true
      if (this.code && this.code.length === CODE_LENGTH) {
        this.codeSent = this.code
        this.startWaitingResponse()
        try {
          const validation = await this.callValidation()
          this.loading = false
          this.endWaitingResponse()
          this.validCode = validation.successful
          this.checkType = validation.type
          this.name = validation.name
          setTimeout(() => {
            if (this.filledCode) {
              this.reset()
            }
          }, 4500)
        } catch (error) {
          console.log('Can not validate', error)
          this.loading = false
        }
      }
    },
    async callValidation() {
      return await sendCheck(this.code, this.context, this.$store)
    },
    startWaitingResponse() {
      this.responseInterval = setInterval(() => {
        if (this.waitingResponse === 100) {
          return (this.waitingResponse = 0)
        }
        this.waitingResponse += 25
      }, 1000)
    },
    endWaitingResponse() {
      this.waitingResponse = 100
      this.clearResponseInterval()
    }
  },
  created() {
    this.code = this.$route.params.id
  }
}
</script>

<style>
.custom-icon-large {
  font-size: 100px !important;
}
.custom-input {
  font-size: 2.6em;
  max-height: 56px;
  padding: 16px;
}
.custom-input input {
  letter-spacing: 0.6rem;
  width: 180px;
  max-height: 50px;
}
</style>
